import { AccessLevelModel } from '../model/types';

export function getAccessLevelLabel(
  accessLevelModel: AccessLevelModel
): string {
  return `user_access_${accessLevelModel}`.toLocaleLowerCase();
}
